<!--
 * @Author: 仙道
 * @Date: 2022-10-28 19:30:07
 * @LastEditTime: 2023-12-06 18:15:32
 * @email: hao.li08@weimob.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/equipment/account/vue/DevModelTab/index.vue
-->
<template>
  <a-tabs>
    <a-tab-pane key="baoy" tab="保养标准">
      <Maintenance :disabled="disabled" :modelId="modelId" />
    </a-tab-pane>
    <a-tab-pane key="bpbj" tab="备品备件">
      <BjTable :disabled="disabled" :model="model" :modelId="modelId" :modelName="modelName" />
    </a-tab-pane>
    <a-tab-pane key="doc" tab="手册资料">
      <dev-doc
        :deviceData="{
          devTypeId: modelId
        }"
        :disabled="disabled"
      />
    </a-tab-pane>
    <a-tab-pane key="param" tab="设备参数">
      <dev-param
        :deviceData="{
          devTypeId: modelId
        }"
        :disabled="disabled"
      />
    </a-tab-pane>
  </a-tabs>
</template>

<script>
import { mapGetters } from 'vuex'
import Maintenance from './Maintenance.vue'
import BjTable from './Bj.vue'

import DevDoc from '@/views/equipment/account/vue/DevDocsList.vue'
import DevParam from '@/views/equipment/account/vue/DevParamList.vue'

export default {
  name: 'DevModelTab',
  components: {
    Maintenance,
    DevDoc,
    DevParam,
    BjTable
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    modelId: {
      type: String,
      default: '',
      required: false
    },
    modelName: {
      type: String,
      default: '',
      required: false
    },
    model: {
      type: Object,
      default: () => {}
    }
  },
  // 定义属性
  data() {
    return {}
  },
  // 计算属性，会监听依赖属性值随之变化
  computed: {
    ...mapGetters([''])
  },
  // 监控data中的数据变化
  watch: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  // 方法集合
  methods: {}
}
</script>

<style lang="scss" scoped>

</style>
